import React from "react"
import { withRouter } from 'react-router-dom'
import SharedModel from "../Common/model"

const Country = ({ match }) => (
  <SharedModel
    modelID={match.params.countryID}
    headerKey={"country"}
    collection={"countries"}
    isEditable={true}
    isDeletable={true}/>
)

export default withRouter(Country)
